import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUserAuth } from "@workspace/login";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const PermissionProtected = ({ requiredPermissions = [], children }) => {
  const userProfile = useSelector((state) => state.Profile.userProfile);
  const location = useLocation();
  const navigate = useNavigate();
  const { checkAllPermission } = useUserAuth();
  const [hasCheckPermission, setHasCheckPermission] = useState(false);

  useEffect(() => {
    setHasCheckPermission(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!hasCheckPermission && userProfile) {
      if (requiredPermissions && requiredPermissions.length > 0) {
        const permissionResult = checkAllPermission(requiredPermissions);
        if (permissionResult) {
          setHasCheckPermission(true);
        } else {
          navigate("/dashboard");
        }
      }

      if (requiredPermissions && requiredPermissions.length === 0) {
        setHasCheckPermission(true);
      }
    }
  }, [requiredPermissions, checkAllPermission, userProfile]);

  if (!hasCheckPermission) {
    return null;
  }
  // Optionally return null if no permission, or handle it as per your needs
  return children;
};

export default PermissionProtected;
